module.exports = __webpack_public_path__ + "media/customizations/gareybldg/logo-new-ee22790e65a04b546acb6b1dcf55fa18.png";